import './style.css'
import { createGame } from './game'

// Initialize the game when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  createGame()
})
